import * as TICKS from './tickers';

// https://www.optimizedportfolio.com/m1-finance-dividend-pie/

export const ed3h1vw1rx0p = {
    id:"ed3h1vw1rx0p",
    title: "Generate Weekly Income", 
    stocks: [
        {"ticker": TICKS.AAPL, "shares": 160}, 
        {"ticker": TICKS.WMT, "shares": 130}, 
        {"ticker": TICKS.CSCO, "shares": 110}, 
        {"ticker": TICKS.T, "shares": 90}, 
        {"ticker": TICKS.JNJ, "shares": 80}, 
        {"ticker": TICKS.MO, "shares": 70}, 
        {"ticker": TICKS.KMB, "shares": 60}, 
        {"ticker": TICKS.WPC, "shares": 50}, 
        {"ticker": TICKS.BX, "shares": 50}, 
        {"ticker": TICKS.CAT, "shares": 50}, 
        {"ticker": TICKS.SPG, "shares": 40}, 
        {"ticker": TICKS.PFE, "shares": 40}, 
        {"ticker": TICKS.LMT, "shares": 40}, 
        {"ticker": TICKS.AVY, "shares": 25},
        {"ticker": TICKS.KHC, "shares": 10}, 
        {"ticker": TICKS.GIS, "shares": 10}, 
        {"ticker": TICKS.PG, "shares": 6}, 
        {"ticker": TICKS.AFL, "shares": 5}, 
    ],
    popularity: 5,
    description: "By combining the various payout schedules, investors can ensure they receive dividend payments on a weekly basis from some of Wall Street’s highest-quality dividend-paying common stocks, EFTs and REITs. All you need is a handful of stocks to make this strategy a reality.",
    source: "https://www.dividend.com/how-to-invest/earn-dividend-income-every-week-12-stock-portfolio/",
};


// export const hv6ee7q8hc2x = {
//     id:"hv6ee7q8hc2x",
//     title: "Warren Buffett's Dividend Portfolio", 
//     stocks: [
//         {"ticker": TICKS.OXY, "shares": 0.2}, 
//         {"ticker": TICKS.KHC, "shares": 4.2}, 
//         {"ticker": TICKS.GM, "shares": 1.3}, 
//         {"ticker": TICKS.SU, "shares": 0.2}, 
//         {"ticker": TICKS.WFC, "shares": 8.9}, 
//         {"ticker": TICKS.STOR, "shares": 0.3}, 
//         {"ticker": TICKS.PSX, "shares": 0.3}, 
//         {"ticker": TICKS.UPS, "shares": 0.01}, 
//         {"ticker": TICKS.KO, "shares": 10.0}, 
//         {"ticker": TICKS.QSR, "shares": 0.3}, 
//         {"ticker": TICKS.PNC, "shares": 0.6}, 
//         {"ticker": TICKS.USB, "shares": 3.4}, 
//         {"ticker": TICKS.JPM, "shares": 3.3}, 
//         {"ticker": TICKS.JNJ, "shares": 0.02}, 
//         {"ticker": TICKS.DAL, "shares": 1.9}, 
//         {"ticker": TICKS.BK, "shares": 1.7}, 
//         {"ticker": TICKS.MTB, "shares": 0.4}, 
//         {"ticker": TICKS.PG, "shares": 0.02}, 
//         {"ticker": TICKS.SYF, "shares": 0.3}, 
//         {"ticker": TICKS.TRV, "shares": 0.4}, 
//         {"ticker": TICKS.GS, "shares": 1.8}, 
//         {"ticker": TICKS.BAC, "shares": 12.4}, 
//         {"ticker": TICKS.MDLZ, "shares": 0.01}, 
//         {"ticker": TICKS.AXP, "shares": 8.3}, 
//         {"ticker": TICKS.LUV, "shares": 1.4}, 
//         {"ticker": TICKS.AAL, "shares": 0.6}, 
//         {"ticker": TICKS.AAPL, "shares": 25.9}, 
//         {"ticker": TICKS.COST, "shares": 0.6}, 
//         {"ticker": TICKS.MCO, "shares": 2.4}, 
//         {"ticker": TICKS.SIRI, "shares": 0.4}, 
//         {"ticker": TICKS.GL, "shares": 0.3}, 
//         {"ticker": TICKS.V, "shares": 0.8}, 
//         {"ticker": TICKS.MA, "shares": 0.6},
//     ],
//     popularity: 4,
//     description: "While Berkshire Hathaway itself does not pay a dividend because it prefers to reinvest all of its earnings for growth, Warren Buffett has certainly not been shy about owning shares of dividend-paying stocks. ",
//     source: "https://www.simplysafedividends.com/intelligent-income/posts/4-warren-buffett-s-dividend-portfolio",
// };


export const jv0xy7kvihpv = {
    id:"jv0xy7kvihpv",
    title: "Income Investing", 
    stocks: [
        {"ticker": TICKS.T, "shares": 17.0}, 
        {"ticker": TICKS.MO, "shares": 14.0}, 
        {"ticker": TICKS.LMT, "shares": 11.0},
        {"ticker": TICKS.AZN, "shares": 8.0}, 
        {"ticker": TICKS.OHI, "shares": 8.0}, 
        {"ticker": TICKS.WBK, "shares": 7.0}, 
        {"ticker": TICKS.TEF, "shares": 7.0}, 
        {"ticker": TICKS.NLY, "shares": 6.0}, 
    ],
    popularity: 3,
    description: "The Income Investing Strategy is a conservative strategy in which, despite requiring a high current yield, it is expected that the yield be fairly stable and reliable. The yield is often looked at as income and used for living expenses. Generally, but not necessarily, this strategy is most suitable for a higher age range with a real or perceived shorter time horizon. To some extent, this strategy is used for bond replacement.",
    source: "https://seekingalpha.com/article/314779-6-types-of-dividend-investment-strategies-part-i",
};


export const ol6bd0nvnc78 = {
    id:"ol6bd0nvnc78",
    title: "High Yield Investing", 
    stocks: [
        {"ticker": TICKS.T, "shares": 14.0}, 
        {"ticker": TICKS.OHI, "shares": 13.0}, 
        {"ticker": TICKS.NLY, "shares": 13.0}, 
        {"ticker": TICKS.TEF, "shares": 11.0}, 
        {"ticker": TICKS.PNNT, "shares": 10.0}, 
        {"ticker": TICKS.BMA, "shares": 9.0}, 
        {"ticker": TICKS.TCAP, "shares": 9.0}, 
        {"ticker": TICKS.SCCO, "shares": 8.0}, 
        {"ticker": TICKS.NPK, "shares": 8.0}, 
        {"ticker": TICKS.NYB, "shares": 8.0}, 
        {"ticker": TICKS.TAL, "shares": 4.0},

    ],
    popularity: 4,
    description: "The objective of the High Yield Investing portfolio is to start with a very high current yield, but at the same time keep sustainability and volatility in mind. The high yield clearly increases risk. To counter-balance the risk, we emphasized a higher level of diversification in this portfolio.",
    source: "https://seekingalpha.com/article/314779-6-types-of-dividend-investment-strategies-part-i",
};


export const x6slgsls1e2w = {
    id:"x6slgsls1e2w",
    title: "Dividend Growth Portfolio", 
    stocks: [
        {"ticker": TICKS.AAPL, "shares": 5.34}, 
        {"ticker": TICKS.ABBV, "shares": 1.51}, 
        {"ticker": TICKS.BLK, "shares": 1.40}, 
        {"ticker": TICKS.CSCO, "shares": 1.32}, 
        {"ticker": TICKS.CVS, "shares": 2.27}, 
        {"ticker": TICKS.DIV, "shares": 1.32}, 
        {"ticker": TICKS.FOF, "shares": 2.26}, 
        {"ticker": TICKS.GLW, "shares": 2.35}, 
        {"ticker": TICKS.HD, "shares": 2.23}, 
        {"ticker": TICKS.IDV, "shares": 3.78}, 
        {"ticker": TICKS.JNJ, "shares": 2.40}, 
        {"ticker": TICKS.MA, "shares": 2.93}, 
        {"ticker": TICKS.MLPA, "shares": 1.57}, 
        {"ticker": TICKS.MO, "shares": 3.39}, 
        {"ticker": TICKS.MSFT, "shares": 0.44}, 
        {"ticker": TICKS.NKE, "shares": 0.87}, 
        {"ticker": TICKS.D, "shares": 6.875}, 
        {"ticker": TICKS.PRU, "shares": 2.65}, 
        {"ticker": TICKS.REM, "shares": 2.73}, 
        {"ticker": TICKS.SBUX, "shares": 2.46}, 
        {"ticker": TICKS.SCHD, "shares": 5.49}, 
        {"ticker": TICKS.SDEM, "shares": 2.34}, 
        {"ticker": TICKS.SDIV, "shares": 3.44}, 
        {"ticker": TICKS.SKT, "shares": 1.68}, 
        {"ticker": TICKS.SPG, "shares": 2.44}, 
        {"ticker": TICKS.SPYD, "shares": 4.35}, 
        {"ticker": TICKS.SRET, "shares": 1.74}, 
        {"ticker": TICKS.V, "shares": 2.91},
    ],
    popularity: 3,
    description: "The aim is to live off dividends without touching the principal. Dividend growth stocks and ETFs are the chosen vehicle to meet that goal.",
    source: "https://seekingalpha.com/article/4315884-dividend-growth-portfolio-2019-review-36-holdings-3-buys-1-sell-3_61-yield-10000-in-dividends",
};


export const fx5ii76xk8v0 = {
    id:"fx5ii76xk8v0",
    title: "Lifetime of Rising Income", 
    stocks: [
        {"ticker": TICKS.XOM, "shares": 6.0}, 
        {"ticker": TICKS.PSX, "shares": 6.0}, 
        {"ticker": TICKS.PM, "shares": 6.0}, 
        {"ticker": TICKS.GIS, "shares": 6.0}, 
        {"ticker": TICKS.PG, "shares": 6.0}, 
        {"ticker": TICKS.WFC, "shares": 6.0}, 
        {"ticker": TICKS.AFL, "shares": 6.0}, 
        {"ticker": TICKS.TROW, "shares": 6.0}, 
        {"ticker": TICKS.JNJ, "shares": 6.0}, 
        {"ticker": TICKS.ABT, "shares": 6.0}, 
        {"ticker": TICKS.PFE, "shares": 6.0}, 
        {"ticker": TICKS.MMM, "shares": 6.0}, 
        {"ticker": TICKS.UTX, "shares": 6.0}, 
        {"ticker": TICKS.WMT, "shares": 6.0}, 
        {"ticker": TICKS.GWW, "shares": 6.0}, 
        {"ticker": TICKS.UNP, "shares": 6.0}, 
        {"ticker": TICKS.MSFT, "shares": 6.0}, 
        {"ticker": TICKS.VZ, "shares": 6.0}, 
        {"ticker": TICKS.SO, "shares": 6.0}, 
        {"ticker": TICKS.ED, "shares": 6.0},
    ],
    popularity: 3,
    description: "Dividend growth investors look for businesses that pay rising dividends year-after-year. For a business to pay increasing dividends every year, it must have a durable competitive advantage.",
    source: "https://thecollegeinvestor.com/17168/how-to-build-a-compounding-dividend-portfolio-for-a-lifetime-of-rising-income/",
};



export const kq7duht3uqmd = {
    id:"kq7duht3uqmd",
    title: "Dividend Diversity Investing", 
    stocks: [
        {"ticker": TICKS.AAPL, "shares": 2.0}, 
        {"ticker": TICKS.ADM, "shares": 2.0}, 
        {"ticker": TICKS.BG, "shares": 2.0}, 
        {"ticker": TICKS.BGS, "shares": 2.0}, 
        {"ticker": TICKS.BP, "shares": 2.0}, 
        {"ticker": TICKS.BUD, "shares": 2.0}, 
        {"ticker": TICKS.CAG, "shares": 2.0}, 
        {"ticker": TICKS.CALM, "shares": 2.0}, 
        {"ticker": TICKS.CAT, "shares": 2.0}, 
        {"ticker": TICKS.CL, "shares": 2.0}, 
        {"ticker": TICKS.CLX, "shares": 2.0}, 
        {"ticker": TICKS.CMI, "shares": 2.0}, 
        {"ticker": TICKS.COF, "shares": 2.0}, 
        {"ticker": TICKS.CSCO, "shares": 2.0}, 
        {"ticker": TICKS.DAL, "shares": 2.0}, 
        {"ticker": TICKS.DFS, "shares": 2.0}, 
        {"ticker": TICKS.F, "shares": 2.0}, 
        {"ticker": TICKS.FAST, "shares": 2.0}, 
        {"ticker": TICKS.GD, "shares": 2.0}, 
        {"ticker": TICKS.GE, "shares": 2.0}, 
        {"ticker": TICKS.GT, "shares": 2.0}, 
        {"ticker": TICKS.HBI, "shares": 2.0}, 
        {"ticker": TICKS.IBM, "shares": 2.0}, 
        {"ticker": TICKS.INGR, "shares": 2.0}, 
        {"ticker": TICKS.INTC, "shares": 2.0}, 
        {"ticker": TICKS.IRM, "shares": 2.0}, 
        {"ticker": TICKS.JNJ, "shares": 2.0}, 
        {"ticker": TICKS.JPM, "shares": 2.0}, 
        {"ticker": TICKS.KHC, "shares": 2.0}, 
        {"ticker": TICKS.KO, "shares": 2.0}, 
        {"ticker": TICKS.KSS, "shares": 2.0}, 
        {"ticker": TICKS.LHX, "shares": 2.0}, 
        {"ticker": TICKS.LUMN, "shares": 2.0}, 
        {"ticker": TICKS.MMM, "shares": 2.0}, 
        {"ticker": TICKS.MSFT, "shares": 2.0}, 
        {"ticker": TICKS.NWL, "shares": 2.0}, 
        {"ticker": TICKS.O, "shares": 2.0}, 
        {"ticker": TICKS.PEP, "shares": 2.0}, 
        {"ticker": TICKS.PFE, "shares": 2.0}, 
        {"ticker": TICKS.PG, "shares": 2.0}, 
        {"ticker": TICKS.SBUX, "shares": 2.0}, 
        {"ticker": TICKS.SJM, "shares": 2.0}, 
        {"ticker": TICKS.SPTN, "shares": 2.0}, 
        {"ticker": TICKS.STX, "shares": 2.0}, 
        {"ticker": TICKS.SYY, "shares": 2.0}, 
        {"ticker": TICKS.T, "shares": 2.0}, 
        {"ticker": TICKS.TSN, "shares": 2.0}, 
        {"ticker": TICKS.UL, "shares": 2.0}, 
        {"ticker": TICKS.UPS, "shares": 2.0}, 
        {"ticker": TICKS.WFC, "shares": 2.0}, 
        {"ticker": TICKS.WPC, "shares": 2.0}, 
        {"ticker": TICKS.WRK, "shares": 2.0}, 
        {"ticker": TICKS.WY, "shares": 2.0}, 
        {"ticker": TICKS.XOM, "shares": 1.0},
    ],
    popularity: 3,
    description: "This portfolio consists of investments in solid, dividend-paying stocks.",
    source: "https://www.moneybyramey.com/dividend-portfolio/",
};


// export const ensau80fscta = {
//     id:"ensau80fscta",
//     title: "High Dividend Solid Stocks", 
//     stocks: [
//         {"ticker": TICKS.SO, "shares": 1.0},
//         {"ticker": TICKS.DUK, "shares": 1.0},
//         {"ticker": TICKS.HTA, "shares": 1.0},
//         {"ticker": TICKS.VZ, "shares": 1.0},
//         {"ticker": TICKS.TU, "shares": 1.0},
//         {"ticker": TICKS.D, "shares": 1.0},
//         {"ticker": TICKS.NHI, "shares": 1.0},
//         {"ticker": TICKS.PM, "shares": 1.0},
//         {"ticker": TICKS.WPC, "shares": 1.0},
//         {"ticker": TICKS.MAIN, "shares": 1.0},
//         {"ticker": TICKS.ENB, "shares": 1.0},
//         {"ticker": TICKS.T, "shares": 1.0},
//         {"ticker": TICKS.MMP, "shares": 1.0},
//         {"ticker": TICKS.EPD, "shares": 1.0},
//         {"ticker": TICKS.BEP, "shares": 1.0},
//     ],
//     popularity: 2,
//     description: "High dividend stocks appeal to many investors living off dividends in retirement because their high yields provide generous income. Many of the highest paying dividend stocks offer a high yield in excess of 4%, and some even yield 10% or more. However, not all high yield dividend stocks are safe.",
//     source: "https://www.simplysafedividends.com/intelligent-income/posts/3-high-dividend-stocks",
// };


export const enpcu80fscta = {
    id:"enpcu80fscta",
    title: "Small Dividend Portfolio", 
    stocks: [
        {"ticker": TICKS.WFC, "shares": 4* 6.22},
        {"ticker": TICKS.T, "shares": 4* 6.15},
        {"ticker": TICKS.AFL, "shares": 4* 6.25},
        {"ticker": TICKS.PFE, "shares": 4* 0.4},
        {"ticker": TICKS.O, "shares": 4* 3.25},
        {"ticker": TICKS.ABBV, "shares": 4* 3.55},
        {"ticker": TICKS.WM, "shares": 4* 0.4},
        {"ticker": TICKS.PEP, "shares": 4* 0.4},
        {"ticker": TICKS.CAT, "shares": 4* 0.6},
        {"ticker": TICKS.KMB, "shares": 4* 0.3},
        {"ticker": TICKS.JNJ, "shares": 4* 0.3},
        {"ticker": TICKS.JPM, "shares": 4* 0.8},
        {"ticker": TICKS.DUK, "shares": 4* 0.5},
        {"ticker": TICKS.MMM, "shares": 4* 1},
        {"ticker": TICKS.HD, "shares": 4* 0.6},
        {"ticker": TICKS.APPL, "shares": 4* 0.4},
        {"ticker": TICKS.MSFT, "shares": 4* 0.2},
        {"ticker": TICKS.MA, "shares": 4* 0.4},
        {"ticker": TICKS.GSP, "shares": 4* 0.6},
        {"ticker": TICKS.VGT, "shares": 4* 0},
        {"ticker": TICKS.VYM, "shares": 4* 0.6},
        {"ticker": TICKS.AAPL, "shares": 4* 0.2},
        {"ticker": TICKS.V, "shares": 4* 0.3},
        {"ticker": TICKS.MAIN, "shares": 4* 0.5},
        // {"ticker": TICKS.VTSAX, "shares": 2.0},
    ],
    popularity: 2,
    description: "Monthly income generated from dividend portfolio consisting of dividends and options premiums using the Wheel Strategy",
    source: "https://www.youtube.com/watch?v=MHmBV6GmdLc",
};
 


export const fa68b9b5201e = {
    id:"fa68b9b5201e",
    title: "FIRE & Income Investors",
    stocks: [
        { "ticker": TICKS.SCHD, "shares": 15, },
        { "ticker": TICKS.HDV, "shares": 5, },
        { "ticker": TICKS.SPYD, "shares": 5, },
        { "ticker": TICKS.VYM, "shares": 10, },
        { "ticker": TICKS.VYMI, "shares": 10, },
        { "ticker": TICKS.VIG, "shares": 5, },
        { "ticker": TICKS.DGRO, "shares": 5, },
        { "ticker": TICKS.VIGI, "shares": 5, },
        { "ticker": TICKS.VNQ, "shares": 10, },
        { "ticker": TICKS.VNQI, "shares": 5, },
        { "ticker": TICKS.USHY, "shares": 5, },
        { "ticker": TICKS.SCHP, "shares": 10, },
        { "ticker": TICKS.IDLV, "shares": 5, },
        { "ticker": TICKS.EDV, "shares": 5, },
    ],
    popularity: 4,
    description: "Many investors, especially those in the FIRE movement (Financial Independence Retire Early), use dividends as regular income and thus attempt to ratchet up their portfolio’s dividend yield.",
    source: "https://www.optimizedportfolio.com/m1-finance-dividend-pie/",
};


export const or7vdoj2r41k = {
    id:"or7vdoj2r41k",
    title: "Post-Dip Portfolio",
    stocks: [
        {"ticker": TICKS.ARE, "shares": 5},
        {"ticker": TICKS.CNP, "shares": 46},
        {"ticker": TICKS.CVS, "shares": 13},
        {"ticker": TICKS.FISV, "shares": 9},
        {"ticker": TICKS.FMC, "shares": 8},
        {"ticker": TICKS.LMT, "shares": 3},
        {"ticker": TICKS.CRM, "shares": 4},
        {"ticker": TICKS.TMUS, "shares": 8},
        {"ticker": TICKS.DIS, "shares": 6},
        {"ticker": TICKS.WMT, "shares": 8},
    ],
    popularity: 4,
    description: "The COVID-19 stock market sell-off has given long-term investors the opportunity to build a portfolio of investments from scratch by buying stocks at a significant discount to where they were trading during the historic bull market.",
    source: "https://money.usnews.com/investing/stock-market-news/slideshows/stocks-to-build-the-model-post-dip-portfolio",
};


export const em0t0dvw0q66 = {
    id:"em0t0dvw0q66",
    title: "Starter Portfolio",
    stocks: [
        {"ticker": TICKS.VTI, "shares": 0}, 
        {"ticker": TICKS.VXUS, "shares": 0}, 
        {"ticker": TICKS.AMZN, "shares": 0}, 
        {"ticker": TICKS.GOOG, "shares": 0}, 
        {"ticker": TICKS.FB, "shares": 0}, 
        {"ticker": TICKS.ISRG, "shares": 0}, 
        {"ticker": TICKS.AAXN, "shares": 0}, 
        {"ticker": TICKS.T, "shares": 0}, 
        {"ticker": TICKS.VZ, "shares": 0}, 
        {"ticker": TICKS.F, "shares": 0}, 
        {"ticker": TICKS.GM, "shares": 0}, 
        {"ticker": TICKS.OKE, "shares": 0}, 
        {"ticker": TICKS.BIP, "shares": 0}, 
        {"ticker": TICKS.CTRE, "shares": 0}, 
        {"ticker": TICKS.IRBT, "shares": 0}, 
        {"ticker": TICKS.LULU, "shares": 0}, 
        {"ticker": TICKS.W, "shares": 0}, 
        {"ticker": TICKS.NFLX, "shares": 0}, 
        {"ticker": TICKS.STZ, "shares": 0}, 
    ],
    popularity: 3,
    description: "A good portfolio example for investors who wish to build out a dividend portfolio with a portion allocated for growth",
    source: "https://www.fool.com/investing/top-stocks-to-buy.aspx",
};


export const caxkuxluhl7u = {
    id:"caxkuxluhl7u",
    title: "Early Investor Portfolio",
    stocks: [
        {"ticker": TICKS.O, "shares": 2}, 
        {"ticker": TICKS.T, "shares": 5}, 
        {"ticker": TICKS.AAPL, "shares": 0}, 
        {"ticker": TICKS.MSFT, "shares": 0}, 
        {"ticker": TICKS.DUK, "shares": 0}, 
        {"ticker": TICKS.DHS, "shares": 0}, 
        {"ticker": TICKS.ATVI, "shares": 0}, 
        {"ticker": TICKS.MGM, "shares": 3}, 
    ],
    popularity: 3,
    description: "A great portfolio example for investors just getting started in their investing journey",
    source: null,
};

export const vyiautvmuj74 = {
    id:"vyiautvmuj74",
    title: "ETF dividend stocks",
    stocks: [
        {"ticker": TICKS.SPHD, "shares": 0}, 
        {"ticker": TICKS.VYM, "shares": 0}, 
        {"ticker": TICKS.SDY, "shares": 0}, 
        {"ticker": TICKS.SCHD, "shares": 0}, 
        {"ticker": TICKS.SJR, "shares": 0}, 
        {"ticker": TICKS.VTI, "shares": 0}, 
        {"ticker": TICKS.VOO, "shares": 0}, 
        {"ticker": TICKS.VIG, "shares": 0}, 
        {"ticker": TICKS.DVY, "shares": 0}, 
        {"ticker": TICKS.DES, "shares": 0}, 
        {"ticker": TICKS.SDOG, "shares": 0}, 
        {"ticker": TICKS.KBWD, "shares": 0}, 
        {"ticker": TICKS.CVY, "shares": 0}, 
        {"ticker": TICKS.HDV, "shares": 0}, 
        {"ticker": TICKS.MGV, "shares": 0}, 
    ],
    popularity: 3,
    description: "vyiautvmuj74",
    source: null,
};

// '', '', '', '', 'j6jzyz4rjkq3', 
// 'kr12iyl64tdz', '799if1fzda3t', '2f8d1ks038f9', '1otjma60x4dj', 's608950eux6a'


export const stocklyme = {
    id:"stocklyme",
    title: "stocklyme",
    stocks: [
        {"ticker": TICKS.VYM, "shares": 210}, 
        {"ticker": TICKS.VOO, "shares": 59}, 
        {"ticker": TICKS.VUG, "shares": 45},
        {"ticker": TICKS.VTI, "shares": 0},
        {"ticker": TICKS.VGT, "shares": 0},
        
        {"ticker": TICKS.SPHD, "shares": 415}, 
        {"ticker": TICKS.SPYD, "shares": 0}, 
        {"ticker": TICKS.SPYG, "shares": 0}, 
        {"ticker": TICKS.SPYV, "shares": 0}, 

        {"ticker": TICKS.O, "shares": 300}, 
        {"ticker": TICKS.ATVI, "shares": 116}, 
        {"ticker": TICKS.MGM, "shares": 143}, 
        {"ticker": TICKS.EA, "shares": 70}, 


        {"ticker": TICKS.TWLO, "shares": 0}, 
        {"ticker": TICKS.ZM, "shares": 0}, 
        {"ticker": TICKS.TSLA, "shares": 0}, 
        {"ticker": TICKS.TTWO, "shares": 0}, 
        {"ticker": TICKS.NET, "shares": 0}, 
        {"ticker": TICKS.FSLY, "shares": 0}, 

        {"ticker": TICKS.SHOP, "shares": 0}, 
        {"ticker": TICKS.TTD, "shares": 0}, 
        {"ticker": TICKS.MDB, "shares": 0}, 
        {"ticker": TICKS.SQ, "shares": 0}, 
        {"ticker": TICKS.CRM, "shares": 0}, 
        {"ticker": TICKS.ZEN, "shares": 0}, 
        {"ticker": TICKS.WIX, "shares": 0}, 
        {"ticker": TICKS.ABNB, "shares": 0}, 
        {"ticker": TICKS.TEAM, "shares": 0}, 
        {"ticker": TICKS.UPWK, "shares": 0}, 
        {"ticker": TICKS.DDOG, "shares": 0}, 
        {"ticker": TICKS.UBER, "shares": 0}, 
        {"ticker": TICKS.LYFT, "shares": 0}, 
        
        {"ticker": TICKS.ASAN, "shares": 0}, 
        {"ticker": TICKS.BYND, "shares": 0}, 
        {"ticker": TICKS.BIGC, "shares": 0}, 
        {"ticker": TICKS.FROG, "shares": 0}, 
        {"ticker": TICKS.LMND, "shares": 0}, 
        {"ticker": TICKS.PLTR, "shares": 0}, 
        {"ticker": TICKS.SUMO, "shares": 0}, 
        {"ticker": TICKS.ZNGA, "shares": 0}, 
        {"ticker": TICKS.UPST, "shares": 0}, 
        {"ticker": TICKS.CLOV, "shares": 0}, 
        {"ticker": TICKS.OPEN, "shares": 0}, 
        
        {"ticker": TICKS.PD, "shares": 0}, 
        {"ticker": TICKS.DBX, "shares": 0}, 
        {"ticker": TICKS.ZUO, "shares": 0}, 
        {"ticker": TICKS.SPT, "shares": 0}, 
        {"ticker": TICKS.SPCE, "shares": 0},
        // {"ticker": TICKS.MNTV, "shares": 0}, 

        {"ticker": TICKS.UAL, "shares": 0}, 
        {"ticker": TICKS.HGV, "shares": 0}, 
        {"ticker": TICKS.RXT, "shares": 0}, 
        {"ticker": TICKS.TWOU, "shares": 0}, 
        {"ticker": TICKS.MDLA, "shares": 0}, 
        {"ticker": TICKS.REAL, "shares": 0},

        // {"ticker": TICKS.HOOD, "shares": 0},
        // {"ticker": TICKS.RELY, "shares": 0},
        // {"ticker": TICKS.BASE, "shares": 0},
        // {"ticker": TICKS.U, "shares": 0},
        // {"ticker": TICKS.FRSH, "shares": 0},
        
        {"ticker": TICKS.AFRM, "shares": 0},

        {"ticker": TICKS.ABBV, "shares": 0}, //01040710
        {"ticker": TICKS.MMM, "shares": 0}, //02050811
        {"ticker": TICKS.KO, "shares": 0}, //03060912
        
        {"ticker": TICKS.ABT, "shares": 0}, //01040710
        {"ticker": TICKS.JNJ, "shares": 0}, //02050811
        {"ticker": TICKS.WMT, "shares": 0}, //03060912
        
        {"ticker": TICKS.CAT, "shares": 0}, //01040710
        {"ticker": TICKS.AFL, "shares": 0}, //02050811
        {"ticker": TICKS.KMB, "shares": 0}, //03060912
        
        {"ticker": TICKS.T,  "shares": 0}, //01040710
        {"ticker": TICKS.TGT, "shares": 0}, //02050811
        {"ticker": TICKS.FRT, "shares": 0}, //03060912
        
        {"ticker": TICKS.PBCT, "shares": 0}, //01040710
        {"ticker": TICKS.MCD, "shares": 0}, //02050811
        {"ticker": TICKS.BEN, "shares": 0}, //03060912
        
        // {"ticker": TICKS.MGV, "shares": 0}, 
        // {"ticker": TICKS.COIN, "shares": 0}, 
        // {"ticker": TICKS.RKT, "shares": 0}, 
        // {"ticker": TICKS.NOW, "shares": 0}, 
        // {"ticker": TICKS.SNOW, "shares": 0}, 
        // {"ticker": TICKS.DT, "shares": 0}, 
        // {"ticker": TICKS.TDOC, "shares": 0}, 
        // {"ticker": TICKS.PS, "shares": 0}, 
    ],
    popularity: 3,
    description: "stocklyme",
    source: "...",
};



export const selfdivvan = {
    id:"selfdivvan",
    title: "selfdivvan",
    stocks: [
        {"ticker": TICKS.VTI, "shares": 30},   //03060912
        {"ticker": TICKS.VOO, "shares": 20},   //03060912
        {"ticker": TICKS.VO, "shares": 20},   //03060912
        {"ticker": TICKS.VUG, "shares": 60},  //03060912
        
        {"ticker": TICKS.VXUS, "shares": 0},  //03060912
        {"ticker": TICKS.VEA, "shares": 0},  //03060912
        {"ticker": TICKS.VXF, "shares": 0},  //03060912
        {"ticker": TICKS.VV, "shares": 0},  //03060912
        {"ticker": TICKS.VTV, "shares": 0},  //03060912
        {"ticker": TICKS.IVOO, "shares": 0},  //03060912

        {"ticker": TICKS.VGT, "shares": 0},   //03060912
        {"ticker": TICKS.VYM, "shares": 0},   //03060912
        {"ticker": TICKS.VYMI, "shares": 0},  //03060912
        {"ticker": TICKS.VIG, "shares": 0},  //03060912
        {"ticker": TICKS.VIGI, "shares": 0},   //03060912

        {"ticker": TICKS.VNQ, "shares": 0},   //03060912
        {"ticker": TICKS.VNQI, "shares": 0},  //03060912

        {"ticker": TICKS.MGV, "shares": 0},  //03060912
        {"ticker": TICKS.VT, "shares": 0},   //03060912

    ],
    popularity: 3,
    description: "selfdivvan",
    source: "...",
};

export const selfdivetf = {
    id:"selfdivetf",
    title: "selfdivetf",
    stocks: [

        // Large Value
        // VYM - 2.8
        // SCHD - 2.9
        // X - MGV - 2.3

        // Large Blend
        // SCHB - 1.4
        // VOO - 1.3
        // X - VIG - 1.7
        // X - MGC - 1.3
        // X - VTI 1.2

        // Large Growth
        // VUG - 0.5
        // SCHG - 0.4

        {"ticker": TICKS.SPHD, "shares": 3000}, //010203040506070809101112
        {"ticker": TICKS.VYM, "shares": 600},   //03060912
        {"ticker": TICKS.VYMI, "shares": 0},  //03060912
        {"ticker": TICKS.VXUS, "shares": 1000},  //03060912
        {"ticker": TICKS.VIG, "shares": 400},  //03060912
        {"ticker": TICKS.VIGI, "shares": 0},   //03060912

        {"ticker": TICKS.VOO, "shares": 100},   //03060912
        {"ticker": TICKS.VGT, "shares": 100},   //03060912
        {"ticker": TICKS.VTI, "shares": 100},   //03060912
        
        {"ticker": TICKS.VNQ, "shares": 200},   //03060912
        {"ticker": TICKS.VNQI, "shares": 200},  //03060912
        {"ticker": TICKS.SPYD, "shares": 400},  //03060912

        {"ticker": TICKS.MGV, "shares": 0},  //03060912
        {"ticker": TICKS.VT, "shares": 0},   //03060912
        {"ticker": TICKS.SCHD, "shares": 0}, //03060912

        {"ticker": TICKS.SPY, "shares": 0},  //01040710

        {"ticker": TICKS.MDYG, "shares": 0}, //03060912
        {"ticker": TICKS.SPGM, "shares": 0}, //0612
        {"ticker": TICKS.VPL, "shares": 600},
        {"ticker": TICKS.VFH, "shares": 600},
        {"ticker": TICKS.IVOG, "shares": 600},
        {"ticker": TICKS.ESGV, "shares": 600},  
        {"ticker": TICKS.VUG, "shares": 600},  
        {"ticker": TICKS.VV, "shares": 600},  
        {"ticker": TICKS.MGC, "shares": 600},  
        {"ticker": TICKS.MGK, "shares": 600},  
        {"ticker": TICKS.VONE, "shares": 600},  
        {"ticker": TICKS.VONG, "shares": 600},  
        {"ticker": TICKS.VONV, "shares": 600},  
        {"ticker": TICKS.VTHR, "shares": 600},  
        {"ticker": TICKS.VOOG, "shares": 600},  
        {"ticker": TICKS.VOOV, "shares": 600},  
        {"ticker": TICKS.VTV, "shares": 600},  
        {"ticker": TICKS.MGC, "shares": 600},  
        {"ticker": TICKS.VXF, "shares": 600},
        {"ticker": TICKS.VO, "shares": 600},
        {"ticker": TICKS.VOT, "shares": 600},
        {"ticker": TICKS.VOE, "shares": 600},
        {"ticker": TICKS.IVOO, "shares": 600},
        {"ticker": TICKS.IVOV, "shares": 600},
        {"ticker": TICKS.VTWO, "shares": 600},
        {"ticker": TICKS.VTWG, "shares": 600},
        {"ticker": TICKS.VTWV, "shares": 600},
        {"ticker": TICKS.VIOO, "shares": 600},
        {"ticker": TICKS.VIOG, "shares": 600},
        {"ticker": TICKS.VIOV, "shares": 600},
        {"ticker": TICKS.VB, "shares": 600},
        {"ticker": TICKS.VBK, "shares": 600},
        {"ticker": TICKS.VBR, "shares": 600},
        {"ticker": TICKS.VSGX, "shares": 600},
        {"ticker": TICKS.VEU, "shares": 600},
        {"ticker": TICKS.VSS, "shares": 600},
        {"ticker": TICKS.VEA, "shares": 600},
        {"ticker": TICKS.VGK, "shares": 600},
        {"ticker": TICKS.VWO, "shares": 600},
        {"ticker": TICKS.VOX, "shares": 600},
        {"ticker": TICKS.VCR, "shares": 600},
        {"ticker": TICKS.VDC, "shares": 600},
        {"ticker": TICKS.VDE, "shares": 600},
        {"ticker": TICKS.VHT, "shares": 600},
        {"ticker": TICKS.VIS, "shares": 600},
        {"ticker": TICKS.VAW, "shares": 600},
        {"ticker": TICKS.VPU, "shares": 600},

    ],
    popularity: 3,
    description: "selfdivetf",
    source: "...",
};



export const selfdivstock = {
    id:"selfdivstock",
    title: "selfdivstock",
    stocks: [
        {"ticker": TICKS.O, "shares": 1600},  //010203040506070809101112

        {"ticker": TICKS.T, "shares": 1800}, //01040710
        {"ticker": TICKS.MMM, "shares": 300}, //02050811
        {"ticker": TICKS.NHI, "shares": 700}, //03060912

        {"ticker": TICKS.CAT, "shares": 100}, //01040710
        {"ticker": TICKS.JNJ, "shares": 300}, //02050811
        {"ticker": TICKS.KO, "shares": 200}, //03060912

        {"ticker": TICKS.PRU, "shares": 600}, //02050811
        {"ticker": TICKS.DUK, "shares": 600}, //02050811
        {"ticker": TICKS.PEP, "shares": 0}, //03060912
        {"ticker": TICKS.PG, "shares": 100}, //01040710
        {"ticker": TICKS.WMT, "shares": 100}, //03060912
        {"ticker": TICKS.AFL, "shares": 200}, //02050811
        {"ticker": TICKS.CL, "shares": 200}, //01040710

        {"ticker": TICKS.DIS, "shares": 0},  //0612

        {"ticker": TICKS.ABT, "shares": 0},
        {"ticker": TICKS.IBM, "shares": 0},
        {"ticker": TICKS.XOM, "shares": 0}, 
        {"ticker": TICKS.SJM, "shares": 0},
        {"ticker": TICKS.GD, "shares": 0},
        {"ticker": TICKS.UTX, "shares": 0},
        {"ticker": TICKS.GWW, "shares": 0},
        {"ticker": TICKS.ABBV, "shares": 0},
        {"ticker": TICKS.CLX, "shares": 0},
        {"ticker": TICKS.KMB, "shares": 0},
        {"ticker": TICKS.SYY, "shares": 0},
        {"ticker": TICKS.ED, "shares": 0},
        {"ticker": TICKS.TROW, "shares": 0},
        {"ticker": TICKS.ADM, "shares": 0},
        {"ticker": TICKS.APAM, "shares": 0},
        {"ticker": TICKS.SAFT, "shares": 0},
        {"ticker": TICKS.WASH, "shares": 0},
        {"ticker": TICKS.PNW, "shares": 0},
        {"ticker": TICKS.PFG, "shares": 0},
        {"ticker": TICKS.OMC, "shares": 0},
        {"ticker": TICKS.NWE, "shares": 0},
        {"ticker": TICKS.EVRG, "shares": 0},
        {"ticker": TICKS.AEP, "shares": 0},
        {"ticker": TICKS.BKH, "shares": 0},
        {"ticker": TICKS.ALE, "shares": 0},
        {"ticker": TICKS.DTE, "shares": 0},
        {"ticker": TICKS.SRE, "shares": 0},
        {"ticker": TICKS.R, "shares": 0},
        {"ticker": TICKS.CHCO, "shares": 0},
        {"ticker": TICKS.BOH, "shares": 0},
        {"ticker": TICKS.EXR, "shares": 0},
        {"ticker": TICKS.MRK, "shares": 0},
        {"ticker": TICKS.IDA, "shares": 0},
        {"ticker": TICKS.AOS, "shares": 0},
        {"ticker": TICKS.CTAS, "shares": 0},
        {"ticker": TICKS.DOV, "shares": 0},
        {"ticker": TICKS.EMR, "shares": 0},
        {"ticker": TICKS.EXPD, "shares": 0},
        {"ticker": TICKS.ITW, "shares": 0},
        {"ticker": TICKS.PNR, "shares": 0},
        {"ticker": TICKS.ROP, "shares": 0},
        {"ticker": TICKS.SWK, "shares": 0},
        {"ticker": TICKS.BDX, "shares": 0},
        {"ticker": TICKS.CAH, "shares": 0},
        {"ticker": TICKS.MDT, "shares": 0},
        {"ticker": TICKS.WST, "shares": 0},
        {"ticker": TICKS.B, "shares": 0},
        {"ticker": TICKS.CHD, "shares": 0},
        {"ticker": TICKS.HRL, "shares": 0},
        {"ticker": TICKS.MKC, "shares": 0},
        {"ticker": TICKS.WBA, "shares": 0},
        {"ticker": TICKS.GPC, "shares": 0},
        {"ticker": TICKS.LEG, "shares": 0},
        {"ticker": TICKS.LOW, "shares": 0},
        {"ticker": TICKS.MCD, "shares": 0},
        {"ticker": TICKS.TGT, "shares": 0},
        {"ticker": TICKS.VFC, "shares": 0},
        {"ticker": TICKS.APD, "shares": 0},
        {"ticker": TICKS.ALB, "shares": 0},
        {"ticker": TICKS.AMCR, "shares": 0},
        {"ticker": TICKS.ECL, "shares": 0},
        {"ticker": TICKS.LIN, "shares": 0},
        {"ticker": TICKS.NUE, "shares": 0},
        {"ticker": TICKS.PPG, "shares": 0},
        {"ticker": TICKS.SHW, "shares": 0},
        {"ticker": TICKS.CB, "shares": 0},
        {"ticker": TICKS.CINF, "shares": 0},
        {"ticker": TICKS.BEN, "shares": 0},
        {"ticker": TICKS.PBCT, "shares": 0},
        {"ticker": TICKS.SPGI, "shares": 0},
        {"ticker": TICKS.ATO, "shares": 0},
        {"ticker": TICKS.ADP, "shares": 0},
        {"ticker": TICKS.CVX, "shares": 0},
        {"ticker": TICKS.ESS, "shares": 0},
        {"ticker": TICKS.FRT, "shares": 0},

    ],
    popularity: 3,
    description: "selfdivstock",
    source: "...",
};




export const selfdivtarget = {
    id:"selfdivtarget",
    title: "selfdivtarget",
    stocks: [
        {"ticker": TICKS.O, "shares": 320},   //010203040506070809101112
        {"ticker": TICKS.SPHD, "shares": 600},   //010203040506070809101112

        {"ticker": TICKS.SPYD, "shares": 0}, //03060912
        {"ticker": TICKS.SPYV, "shares": 0}, //03060912
        {"ticker": TICKS.SPYG, "shares": 0}, //03060912

        {"ticker": TICKS.VTI, "shares": 110},   //03060912
        {"ticker": TICKS.VOO, "shares": 60},   //03060912
        {"ticker": TICKS.VYM, "shares": 240},   //03060912
        {"ticker": TICKS.VGT, "shares": 65},   //03060912

        // {"ticker": TICKS.NOBL, "shares": 80},   
        
        {"ticker": TICKS.ABBV, "shares": 50}, //01040710
        {"ticker": TICKS.MMM, "shares": 30}, //02050811
        {"ticker": TICKS.KO, "shares": 100}, //03060912

        {"ticker": TICKS.ABT, "shares": 40}, //01040710
        {"ticker": TICKS.JNJ, "shares": 30}, //02050811
        {"ticker": TICKS.WMT, "shares": 35}, //03060912

        {"ticker": TICKS.CAT, "shares": 25}, //01040710
        {"ticker": TICKS.AFL, "shares": 100}, //02050811
        {"ticker": TICKS.KMB, "shares": 40}, //03060912

        {"ticker": TICKS.T,  "shares": 170}, //01040710
        {"ticker": TICKS.TGT, "shares": 30}, //02050811
        {"ticker": TICKS.FRT, "shares": 50}, //03060912
        
        {"ticker": TICKS.PBCT, "shares": 270}, //01040710
        {"ticker": TICKS.MCD, "shares": 24}, //02050811
        {"ticker": TICKS.BEN, "shares": 185}, //03060912

    ],
    popularity: 3,
    description: "selfdivtarget",
    source: "...",
};


// champions
// challengers
// acheivers
// kings
// blue chip
export const selfdivaristrocrats = {
    id:"selfdivaristrocrats",
    title: "selfdivaristrocrats",
    stocks: [
        {"ticker": TICKS.O, "shares": 0},
        
        {"ticker": TICKS.ABBV, "shares": 48}, //01040710
        {"ticker": TICKS.MMM, "shares": 28}, //02050811
        {"ticker": TICKS.KO, "shares": 100}, //03060912

        {"ticker": TICKS.T,  "shares": 171}, //01040710
        {"ticker": TICKS.JNJ, "shares": 31}, //02050811
        {"ticker": TICKS.KMB, "shares": 38}, //03060912
        
        {"ticker": TICKS.LOW, "shares": 30}, //01040710
        {"ticker": TICKS.AFL, "shares": 101}, //02050811
        {"ticker": TICKS.WMT, "shares": 37}, //03060912
        
        {"ticker": TICKS.CAT, "shares": 23}, //01040710
        {"ticker": TICKS.TGT, "shares": 27}, //02050811
        {"ticker": TICKS.FRT, "shares": 48}, //03060912
        
        {"ticker": TICKS.PG, "shares": 40}, //01040710
        {"ticker": TICKS.MCD, "shares": 24}, //02050811
        {"ticker": TICKS.BEN, "shares": 185}, //03060912
        
        {"ticker": TICKS.ABT, "shares": 0/*40*/}, //01040710
        {"ticker": TICKS.HRL, "shares": 0}, //01040710
        {"ticker": TICKS.CLX, "shares": 0}, //01040710
        {"ticker": TICKS.CL, "shares": 0}, //01040710
        {"ticker": TICKS.PBCT, "shares": 0/*250*/}, //01040710
        {"ticker": TICKS.GD, "shares": 0}, //01040710
        {"ticker": TICKS.PNR, "shares": 0}, //01040710
        {"ticker": TICKS.ROP, "shares": 0}, //01040710
        {"ticker": TICKS.WST, "shares": 0}, //01040710
        {"ticker": TICKS.AOS, "shares": 0}, //01040710

        {"ticker": TICKS.ED, "shares": 0}, //02050811
        {"ticker": TICKS.CVX, "shares": 0}, //02050811
        {"ticker": TICKS.XOM, "shares": 0}, //02050811
        {"ticker": TICKS.IBM, "shares": 0}, //02050811
        {"ticker": TICKS.WBA, "shares": 0}, //02050811
        {"ticker": TICKS.EMR, "shares": 0}, //02050811
        {"ticker": TICKS.GWW, "shares": 0}, //02050811
        {"ticker": TICKS.ATO, "shares": 0}, //02050811
        {"ticker": TICKS.SPGI, "shares": 0}, //02050811
        {"ticker": TICKS.DOV, "shares": 0}, //02050811

        {"ticker": TICKS.ADP, "shares": 0}, //03060912
        {"ticker": TICKS.PEP, "shares": 0}, //03060912
        {"ticker": TICKS.CAH, "shares": 0}, //03060912
        {"ticker": TICKS.ITW, "shares": 0}, //03060912
        {"ticker": TICKS.SWK, "shares": 0}, //03060912
        {"ticker": TICKS.ESS, "shares": 0}, //03060912
        {"ticker": TICKS.CINF, "shares": 0}, //03060912
        {"ticker": TICKS.TROW, "shares": 0}, //03060912
        {"ticker": TICKS.BDX, "shares": 0}, //03060912
        {"ticker": TICKS.MDT, "shares": 0}, //03060912

        {"ticker": TICKS.GPC, "shares": 0},
        {"ticker": TICKS.LEG, "shares": 0},
        {"ticker": TICKS.VFC, "shares": 0},
        {"ticker": TICKS.APD, "shares": 0},
        {"ticker": TICKS.ALB, "shares": 0},
        {"ticker": TICKS.AMCR, "shares": 0},
        {"ticker": TICKS.ECL, "shares": 0},
        {"ticker": TICKS.LIN, "shares": 0},
        {"ticker": TICKS.NUE, "shares": 0},
        {"ticker": TICKS.PPG, "shares": 0},
        {"ticker": TICKS.SHW, "shares": 0},
        {"ticker": TICKS.ADM, "shares": 0},
        {"ticker": TICKS.CHD, "shares": 0},
        {"ticker": TICKS.MKC, "shares": 0},
        {"ticker": TICKS.SYY, "shares": 0},
        {"ticker": TICKS.CB, "shares": 0},
        
        {"ticker": TICKS.UTX, "shares": 0},
        {"ticker": TICKS.CTAS, "shares": 0}, //11
        {"ticker": TICKS.EXPD, "shares": 0}, //0511
    ],
    popularity: 3,
    description: "selfdivaristrocrats",
    source: "...",
};


export const selfdivcontenders = {
    id:"selfdivcontenders",
    title: "selfdivcontenders",
    stocks: [

        {"ticker": TICKS.DUK, "shares": 0}, //02050811
        {"ticker": TICKS.VZ, "shares": 0}, //01040710
        {"ticker": TICKS.K, "shares": 0}, //02050811
        {"ticker": TICKS.NHC, "shares": 0}, //03060912
        {"ticker": TICKS.WM, "shares": 0}, //03060912

        {"ticker": TICKS.OZK, "shares": 0}, //01040710
        {"ticker": TICKS.FLIC, "shares": 0}, //01040710
        
        {"ticker": TICKS.IBM, "shares": 0}, //02050811
        {"ticker": TICKS.PII, "shares": 0}, //02050811
        {"ticker": TICKS.CHD, "shares": 0}, //02050811
        {"ticker": TICKS.TJX, "shares": 0}, //02050811

        {"ticker": TICKS.CNI, "shares": 0}, //03060912
        {"ticker": TICKS.NJR, "shares": 0}, //03060912
        {"ticker": TICKS.RNR, "shares": 0}, //03060912

        {"ticker": TICKS.ENB, "shares": 0},
        {"ticker": TICKS.CCFN, "shares": 0},
        {"ticker": TICKS.CZFS, "shares": 0},
        {"ticker": TICKS.LYBC, "shares": 0},
        {"ticker": TICKS.BKUTK, "shares": 0},

        {"ticker": TICKS.GGG, "shares": 0}, //01040710
        {"ticker": TICKS.EPD, "shares": 0}, //01040710
        {"ticker": TICKS.NWFL, "shares": 0}, //01040710
        {"ticker": TICKS.CASY, "shares": 0}, //01040710
        {"ticker": TICKS.FAST, "shares": 0}, //01040710

        {"ticker": TICKS.SJM, "shares": 0}, //02050811
        {"ticker": TICKS.MMP, "shares": 0}, //02050811
        {"ticker": TICKS.NUS, "shares": 0}, //02050811
        {"ticker": TICKS.RBA, "shares": 0}, //02050811
        {"ticker": TICKS.FDS, "shares": 0}, //02050811
        {"ticker": TICKS.EBMT, "shares": 0}, //02050811
        {"ticker": TICKS.CATC, "shares": 0}, //02050811

        {"ticker": TICKS.WPC, "shares": 0}, //03060912
        {"ticker": TICKS.YORW, "shares": 0}, //03060912
        {"ticker": TICKS.CHRW, "shares": 0}, //03060912
        {"ticker": TICKS.PB, "shares": 0}, //03060912
        {"ticker": TICKS.ES, "shares": 0}, //03060912
        {"ticker": TICKS.RBCAA, "shares": 0}, //03060912
        {"ticker": TICKS.SJI, "shares": 0}, //03060912

        {"ticker": TICKS.NKSH, "shares": 0}, //0511

        {"ticker": TICKS.RGLD, "shares": 0},
        {"ticker": TICKS.SO, "shares": 0},
        {"ticker": TICKS.ANDE, "shares": 0},
        {"ticker": TICKS.AUBN, "shares": 0},
        {"ticker": TICKS.BG, "shares": 0},
        {"ticker": TICKS.AXS, "shares": 0},
        {"ticker": TICKS.CASS, "shares": 0},
        {"ticker": TICKS.FDX, "shares": 0},
        {"ticker": TICKS.FLO, "shares": 0},
        {"ticker": TICKS.LHX, "shares": 0},
        {"ticker": TICKS.LARK, "shares": 0},
        {"ticker": TICKS.MXIM, "shares": 0},
        {"ticker": TICKS.MCHP, "shares": 0},
        {"ticker": TICKS.MSFT, "shares": 0},
        {"ticker": TICKS.MYBF, "shares": 0},
        {"ticker": TICKS.NKE, "shares": 0},
        {"ticker": TICKS.PPL, "shares": 0},
        {"ticker": TICKS.THVB, "shares": 0},
        {"ticker": TICKS.WRB, "shares": 0},
        {"ticker": TICKS.AAN, "shares": 0},
        {"ticker": TICKS.ACU, "shares": 0},
        {"ticker": TICKS.ADI, "shares": 0},
        {"ticker": TICKS.ATRI, "shares": 0},
        {"ticker": TICKS.AVA, "shares": 0},
        {"ticker": TICKS.DGICA, "shares": 0},
        {"ticker": TICKS.DGICB, "shares": 0},
        {"ticker": TICKS.EIX, "shares": 0},
        {"ticker": TICKS.HCSG, "shares": 0},
        {"ticker": TICKS.IFF, "shares": 0},
        {"ticker": TICKS.LNN, "shares": 0},
        {"ticker": TICKS.LMT, "shares": 0},
        {"ticker": TICKS.MSM, "shares": 0},
        {"ticker": TICKS.NHI, "shares": 0},
        {"ticker": TICKS.ODC, "shares": 0},
        {"ticker": TICKS.OHI, "shares": 0},
        {"ticker": TICKS.OKE, "shares": 0},
        {"ticker": TICKS.PRGO, "shares": 0},
        {"ticker": TICKS.QCOM, "shares": 0},
        {"ticker": TICKS.RGCO, "shares": 0},
        {"ticker": TICKS.RSG, "shares": 0},
        {"ticker": TICKS.SR, "shares": 0},
        {"ticker": TICKS.TIF, "shares": 0},
        {"ticker": TICKS.WEC, "shares": 0},
        {"ticker": TICKS.UTMD, "shares": 0},
        {"ticker": TICKS.XLNX, "shares": 0},
        {"ticker": TICKS.LNT, "shares": 0},
        {"ticker": TICKS.BHB, "shares": 0},
        {"ticker": TICKS.BBY, "shares": 0},
        {"ticker": TICKS.CPK, "shares": 0},
        {"ticker": TICKS.COST, "shares": 0},
        {"ticker": TICKS.D, "shares": 0},
        {"ticker": TICKS.FMAO, "shares": 0},
        {"ticker": TICKS.HAS, "shares": 0},
        {"ticker": TICKS.JBHT, "shares": 0},
        {"ticker": TICKS.JJSF, "shares": 0},
        
        {"ticker": TICKS.NOC, "shares": 0},
        {"ticker": TICKS.RHI, "shares": 0},
        {"ticker": TICKS.SRE, "shares": 0},
        {"ticker": TICKS.SLGN, "shares": 0},
        {"ticker": TICKS.TXN, "shares": 0},
        {"ticker": TICKS.TPL, "shares": 0},
        
        {"ticker": TICKS.VSEC, "shares": 0},
        {"ticker": TICKS.WLK, "shares": 0},
        {"ticker": TICKS.XEL, "shares": 0},
        {"ticker": TICKS.ABC, "shares": 0},
        {"ticker": TICKS.ACN, "shares": 0},
        {"ticker": TICKS.AMP, "shares": 0},
        {"ticker": TICKS.BMRC, "shares": 0},
        {"ticker": TICKS.BOKF, "shares": 0},
        {"ticker": TICKS.CNP, "shares": 0},
        {"ticker": TICKS.CSX, "shares": 0},
        {"ticker": TICKS.DLR, "shares": 0},
        
        {"ticker": TICKS.ELS, "shares": 0},
        {"ticker": TICKS.EVRG, "shares": 0},
        {"ticker": TICKS.HEP, "shares": 0},
        {"ticker": TICKS.HONT, "shares": 0},
        {"ticker": TICKS.LSTR, "shares": 0},
        {"ticker": TICKS.MNRO, "shares": 0},
        {"ticker": TICKS.NWE, "shares": 0},
        {"ticker": TICKS.RBC, "shares": 0},
        {"ticker": TICKS.R, "shares": 0},
        {"ticker": TICKS.STE, "shares": 0},
        {"ticker": TICKS.TRV, "shares": 0},
        
        {"ticker": TICKS.AFG, "shares": 0},
        {"ticker": TICKS.AMNF, "shares": 0},
        {"ticker": TICKS.CMI, "shares": 0},
        {"ticker": TICKS.KR, "shares": 0},
        {"ticker": TICKS.NEU, "shares": 0},
        {"ticker": TICKS.POR, "shares": 0},
        {"ticker": TICKS.SXT, "shares": 0},
        {"ticker": TICKS.THG, "shares": 0},
        {"ticker": TICKS.WSM, "shares": 0},
        {"ticker": TICKS.BR, "shares": 0},
        {"ticker": TICKS.CMS, "shares": 0},
        {"ticker": TICKS.ENSG, "shares": 0},
        {"ticker": TICKS.EVR, "shares": 0},
        {"ticker": TICKS.FFMR, "shares": 0},
        {"ticker": TICKS.HEI, "shares": 0},
        {"ticker": TICKS.HI, "shares": 0},
        {"ticker": TICKS.HIFS, "shares": 0},
        {"ticker": TICKS.OGE, "shares": 0},
        {"ticker": TICKS.SWX, "shares": 0},
        {"ticker": TICKS.UNP, "shares": 0},
        {"ticker": TICKS.AWK, "shares": 0},
        {"ticker": TICKS.BIP, "shares": 0},
        {"ticker": TICKS.CMCSA, "shares": 0},
        {"ticker": TICKS.FNV, "shares": 0},
        {"ticker": TICKS.LAZ, "shares": 0},
        {"ticker": TICKS.LMNR, "shares": 0},
        {"ticker": TICKS.MCK, "shares": 0},
        {"ticker": TICKS.PM, "shares": 0},
        {"ticker": TICKS.QNTO, "shares": 0},
        {"ticker": TICKS.KMR, "shares": 0},
        {"ticker": TICKS.V, "shares": 0},
        {"ticker": TICKS.CHE, "shares": 0},
        {"ticker": TICKS.DTE, "shares": 0},
        {"ticker": TICKS.IPAR, "shares": 0},
        {"ticker": TICKS.MKTX, "shares": 0},
        {"ticker": TICKS.ORCL, "shares": 0},
        {"ticker": TICKS.PFG, "shares": 0},
        {"ticker": TICKS.PRU, "shares": 0},
        {"ticker": TICKS.RGA, "shares": 0},
        {"ticker": TICKS.TTC, "shares": 0},
        {"ticker": TICKS.UNM, "shares": 0},
        {"ticker": TICKS.WDFC, "shares": 0},
        {"ticker": TICKS.WRK, "shares": 0},
        {"ticker": TICKS.BCPC, "shares": 0},
        {"ticker": TICKS.BMY, "shares": 0},
        {"ticker": TICKS.CMD, "shares": 0},
        {"ticker": TICKS.COR, "shares": 0},
        {"ticker": TICKS.PETS, "shares": 0},
        {"ticker": TICKS.AEP, "shares": 0},
        {"ticker": TICKS.AIT, "shares": 0},
        {"ticker": TICKS.ASH, "shares": 0},
        {"ticker": TICKS.ATVI, "shares": 0},
        {"ticker": TICKS.BEP, "shares": 0},
        {"ticker": TICKS.BLK, "shares": 0},
        {"ticker": TICKS.CBOE, "shares": 0},
        {"ticker": TICKS.CE, "shares": 0},
        {"ticker": TICKS.CHS, "shares": 0},
        {"ticker": TICKS.CMA, "shares": 0},
        {"ticker": TICKS.CNS, "shares": 0},
        {"ticker": TICKS.ETN, "shares": 0},
        {"ticker": TICKS.EXR, "shares": 0},
        {"ticker": TICKS.FIBK, "shares": 0},
        {"ticker": TICKS.GPI, "shares": 0},
        {"ticker": TICKS.HD, "shares": 0},
        {"ticker": TICKS.HMN, "shares": 0},
        {"ticker": TICKS.HPQ, "shares": 0},
        {"ticker": TICKS.HSY, "shares": 0},
        {"ticker": TICKS.HVT, "shares": 0},
        {"ticker": TICKS.HVT, "shares": 0},
        {"ticker": TICKS.IBOC, "shares": 0},
        {"ticker": TICKS.IEX, "shares": 0},
        {"ticker": TICKS.IP, "shares": 0},
        {"ticker": TICKS.IRM, "shares": 0},
        {"ticker": TICKS.KLAC, "shares": 0},
        {"ticker": TICKS.LAD, "shares": 0},
        {"ticker": TICKS.LFUS, "shares": 0},
        {"ticker": TICKS.LII, "shares": 0},
        {"ticker": TICKS.LNC, "shares": 0},
        {"ticker": TICKS.MCO, "shares": 0},
        {"ticker": TICKS.MMC, "shares": 0},
        {"ticker": TICKS.MSI, "shares": 0},
        {"ticker": TICKS.NRIM, "shares": 0},
        {"ticker": TICKS.NWBI, "shares": 0},
        {"ticker": TICKS.OMC, "shares": 0},
        {"ticker": TICKS.PLOW, "shares": 0},
        {"ticker": TICKS.PNBI, "shares": 0},
        {"ticker": TICKS.PRI, "shares": 0},
        // {"ticker": TICKS.POL, "shares": 0},
        // {"ticker": TICKS.AMTD, "shares": 0},
        // {"ticker": TICKS.RECN, "shares": 0},
        {"ticker": TICKS.ROIC, "shares": 0},
        {"ticker": TICKS.ROK, "shares": 0},
        {"ticker": TICKS.SBUX, "shares": 0},
        {"ticker": TICKS.SMG, "shares": 0},
        {"ticker": TICKS.SMP, "shares": 0},
        {"ticker": TICKS.SNA, "shares": 0},
        {"ticker": TICKS.SPG, "shares": 0},
        {"ticker": TICKS.SYBT, "shares": 0},
        {"ticker": TICKS.TBNK, "shares": 0},
        {"ticker": TICKS.TCO, "shares": 0},
        {"ticker": TICKS.THO, "shares": 0},
        {"ticker": TICKS.TSCO, "shares": 0},
        {"ticker": TICKS.TTC, "shares": 0},
        {"ticker": TICKS.UFS, "shares": 0},
        {"ticker": TICKS.UNH, "shares": 0},
        {"ticker": TICKS.UPS, "shares": 0},
        {"ticker": TICKS.WCN, "shares": 0},
        {"ticker": TICKS.WDFC, "shares": 0},
        {"ticker": TICKS.WEN, "shares": 0},
        {"ticker": TICKS.WYND, "shares": 0},
    ],
    popularity: 3,
    description: "selfdivcontenders",
    source: "...",
};

// VFIAX 
// VOO
// VTSAX 
// VTI
// SWPPX 
// SWTSX
// FXIAX
// FZILX
// FZROX
// FNILX



// BEST DIVIDEND ETF TO INVEST IN (2021) The Power of Dividend Investing
// comments: Look at teh table for column ideas
// https://www.youtube.com/watch?v=6zNerDcd0NU
// TICKS.VYM, 
// TICKS.VIG, 
// TICKS.SCHD,
// TICKS.HDV,
// TICKS.SPYD,
// TICKS.SDY,
// SPHQ,
// NOBL,  .. Dividend aristrocrat ETF
// DGRW,
// TICKS.DHS,



// Monthly dividends
// https://www.youtube.com/watch?v=TyfmDhjRZFc